import { render, staticRenderFns } from "./article.vue?vue&type=template&id=23a75bfa&scoped=true"
import script from "./article.vue?vue&type=script&lang=ts"
export * from "./article.vue?vue&type=script&lang=ts"
import style0 from "./article.vue?vue&type=style&index=0&id=23a75bfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a75bfa",
  null
  
)

export default component.exports